import React from 'react';

import { ISVGPersonalProps } from 'types/svg';

export const column: ISVGPersonalProps = {
  viewBox: '0 0 12 12',
  content: (
    <g id="column_icon" data-name="column icon" transform="translate(-277.658 -645.793)">
      <path
        id="Path_7173"
        data-name="Path 7173"
        d="M168.678,176.8a.375.375,0,0,1-.364-.46l.544-2.308a.37.37,0,0,1,.1-.179l4.764-4.764a1.149,1.149,0,0,1,1.588,0l.706.706a1.122,1.122,0,0,1,0,1.587l-4.764,4.763a.375.375,0,0,1-.179.1l-2.308.544a.342.342,0,0,1-.086.01m.884-2.493-.381,1.616,1.616-.381,4.688-4.688a.373.373,0,0,0,0-.529l-.706-.706a.375.375,0,0,0-.529,0Zm1.425,1.575h0Z"
        transform="translate(113.315 480.994)"
        fill="#79cdd0"
      />
      <path
        id="Path_7174"
        data-name="Path 7174"
        d="M344.545,232.962a.372.372,0,0,1-.265-.11l-1.765-1.765a.374.374,0,1,1,.529-.529l1.765,1.765a.375.375,0,0,1-.265.639"
        transform="translate(-56.715 420.749)"
        fill="#79cdd0"
      />
      <path
        id="Path_7175"
        data-name="Path 7175"
        d="M3.413,10.5H1.123A1.125,1.125,0,0,1,0,9.378V1.125A1.125,1.125,0,0,1,1.123,0H8.359A1.125,1.125,0,0,1,9.482,1.125V3.441a.374.374,0,1,1-.749,0V1.125A.375.375,0,0,0,8.359.75H1.123a.375.375,0,0,0-.374.375V9.378a.375.375,0,0,0,.374.375H3.413a.375.375,0,0,1,0,.75"
        transform="translate(277.658 645.793)"
        fill="#79cdd0"
      />
      <path
        id="Path_7176"
        data-name="Path 7176"
        d="M9.107,107.417H.374a.374.374,0,0,1,0-.749H9.107a.374.374,0,0,1,0,.749"
        transform="translate(277.658 541.625)"
        fill="#79cdd0"
      />
      <path
        id="Path_7177"
        data-name="Path 7177"
        d="M7.271,214.081H.374a.374.374,0,1,1,0-.749h6.9a.374.374,0,1,1,0,.749"
        transform="translate(277.658 437.462)"
        fill="#79cdd0"
      />
      <path
        id="Path_7178"
        data-name="Path 7178"
        d="M4.741,320.749H.374a.374.374,0,1,1,0-.749H4.741a.374.374,0,1,1,0,.749"
        transform="translate(277.658 333.294)"
        fill="#79cdd0"
      />
      <path
        id="Path_7179"
        data-name="Path 7179"
        d="M187.042,112.407a.374.374,0,0,1-.374-.374v-4.99a.374.374,0,1,1,.749,0v4.99a.374.374,0,0,1-.374.374"
        transform="translate(95.366 541.63)"
        fill="#79cdd0"
      />
    </g>
  ),
};
